import { takeLatest, put, all, call } from 'redux-saga/effects';
import funderDetailsActionTypes from './funder-details.types';
import {
	getFunderDetailsListSuccess,
	getFunderDetailsListFailure,
	getFunderDetailsListChanged,
	addFunderDetailsSuccess,
	addFunderDetailsFailure,
	addFunderDetailsChanged,
	updateFunderDetailsSuccess,
	updateFunderDetailsFailure,
	updateFunderDetailsChanged,
	deleteFunderDetailsSuccess,
	deleteFunderDetailsFailure,
	deleteFunderDetailsChanged,
	fetchAllInvestmentRepaymentListResponseChanged,
	fetchInvestmentProductInvestmentAmountFailure,
	fetchInvestmentProductInvestmentAmountSuccess,
	fetchInvestmentProductInvestmentAmountResponseChanged,
	fetchAllInvestmentMadeListFailure,
	fetchAllInvestmentMadeListSuccess,
	fetchAllInvestmentMadeListResponseChanged,
	fetchAllInvestmentRepaymentListFailure,
	fetchAllInvestmentRepaymentListSuccess,
	createInvestorMadeFailure,
	createInvestorMadeSuccess,
	createInvestorMadeChanged,
	getBranchAccountListFailure,
	getBranchAccountListSuccess,
	getBranchAccountListChanged,
	getRepaymentScheduleSuccess,
	getRepaymentScheduleChanged,
	getRepaymentScheduleFailure,
	getInvestorsDetailsChanged,
	getInvestorsDetailsFailure,
	getInvestorsDetailsSuccess,
} from './funder-details.action';

import {
	getFunderDetailsList,
	addFunderDetails,
	updateFunderDetails,
	deleteFunderDetails,
	fetchInvestmentProductInvestmentAmount,
	getAllInvestmentRepaymentList,
	fetchAllInvestmentMadeList,
	createInvestorMadeFun,
	getInvestorDetailsFun,
	getBranchAccountListFun,
	getRepaymentScheduleDetails,
} from './funder-details.service';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ********************* GET FUNDER DETAILS LIST START ********************* */
export function* funderDetailsListGet({ payload }: any) {
	try {
		const key = 'GetAllInvestorDetailsKey';
		const { companyID, databaseName, userID, userLevel } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getFunderDetailsList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getFunderDetailsListFailure(responseData.data));
		} else {
			yield put(getFunderDetailsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getFunderDetailsListFailure(error));
	}
}

export function* resetGetFunderDetailsList() {
	yield put(getFunderDetailsListChanged());
}

export function* onGetFunderDetailsListStart() {
	yield takeLatest(funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_START, funderDetailsListGet);
}

export function* onGetFunderDetailsListReset() {
	yield takeLatest(
		funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_RESET,
		resetGetFunderDetailsList,
	);
}
/** ********************* GET FUNDER DETAILS LIST END ********************* */

/** ********************* ADD FUNDER DETAILS START ********************* */
export function* addFunderDetailsStart({ payload }: any) {
	try {
		const key = 'AddFunderDetailsKey';
		const { companyID, databaseName, userID, funderName, contactPerson, email, phone } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			FunderName: funderName,
			ContactPerson: contactPerson,
			Email: email,
			Phone: phone,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addFunderDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addFunderDetailsFailure(responseData.data));
		} else {
			yield put(addFunderDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addFunderDetailsFailure(error));
	}
}

export function* resetAddFunderDetails() {
	yield put(addFunderDetailsChanged());
}

export function* onAddFunderDetailsStart() {
	yield takeLatest(funderDetailsActionTypes.ADD_FUNDER_DETAILS_START, addFunderDetailsStart);
}

export function* onAddFunderDetailsReset() {
	yield takeLatest(funderDetailsActionTypes.ADD_FUNDER_DETAILS_RESET, resetAddFunderDetails);
}
/** ********************* ADD FUNDER DETAILS END ********************* */

/** ********************* UPDATE FUNDER DETAILS START ********************* */
export function* updateFunderDetailsStart({ payload }: any) {
	try {
		const key = 'UpdateFunderDetailsKey';
		const {
			companyID,
			databaseName,
			userID,
			funderID,
			funderName,
			contactPerson,
			email,
			phone,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			FunderID: funderID,
			FunderName: funderName,
			ContactPerson: contactPerson,
			Email: email,
			Phone: phone,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateFunderDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateFunderDetailsFailure(responseData.data));
		} else {
			yield put(updateFunderDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateFunderDetailsFailure(error));
	}
}

export function* resetUpdateFunderDetails() {
	yield put(updateFunderDetailsChanged());
}

export function* onUpdateFunderDetailsStart() {
	yield takeLatest(
		funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_START,
		updateFunderDetailsStart,
	);
}

export function* onUpdateFunderDetailsReset() {
	yield takeLatest(
		funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_RESET,
		resetUpdateFunderDetails,
	);
}
/** ********************* UPDATE FUNDER DETAILS END ********************* */

/** ********************* DELETE FUNDER DETAILS START ********************* */
export function* deleteFunderDetailsStart({ payload }: any) {
	try {
		const key = 'DeleteFunderDetailsKey';
		const { companyID, databaseName, userID, funderID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			FunderID: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteFunderDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteFunderDetailsFailure(responseData.data));
		} else {
			yield put(deleteFunderDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteFunderDetailsFailure(error));
	}
}

export function* resetDeleteFunderDetails() {
	yield put(deleteFunderDetailsChanged());
}

export function* onDeleteFunderDetailsStart() {
	yield takeLatest(
		funderDetailsActionTypes.DELETE_FUNDER_DETAILS_START,
		deleteFunderDetailsStart,
	);
}

export function* onDeleteFunderDetailsReset() {
	yield takeLatest(
		funderDetailsActionTypes.DELETE_FUNDER_DETAILS_RESET,
		resetDeleteFunderDetails,
	);
}
/** ********************* DELETE FUNDER DETAILS END ********************* */

/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT START ************************** */
export function* fetchInvestmentProductInvestmentAmountFun({ payload }: any) {
	const { Limit, investorID, branchID, databaseName } = payload;
	try {
		const key = 'FetchInvestmentProductInvestmentAmountKey';
		const jsonData = {
			Limit,
			branchID,
			investorID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchInvestmentProductInvestmentAmount, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchInvestmentProductInvestmentAmountFailure(responseData.data));
		} else {
			yield put(fetchInvestmentProductInvestmentAmountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchInvestmentProductInvestmentAmountFailure(error));
	}
}

export function* resetFetchInvestmentProductInvestmentAmountResponse() {
	yield put(fetchInvestmentProductInvestmentAmountResponseChanged());
}

export function* onFetchInvestmentProductInvestmentAmount() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_START,
		fetchInvestmentProductInvestmentAmountFun,
	);
}

export function* onFetchInvestmentProductInvestmentAmountResponseReset() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_RESET,
		resetFetchInvestmentProductInvestmentAmountResponse,
	);
}

/************** FETCH ALL INVESTMENT MADE LIST START ************************** */
export function* fetchAllInvestmentMadeListFun({ payload }: any) {
	const { Limit, investorID, branchID, databaseName } = payload;
	try {
		const key = 'FetchAllInvestmentMadeListKey';
		const jsonData = {
			Limit,
			branchID,
			investorID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAllInvestmentMadeList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllInvestmentMadeListFailure(responseData.data));
		} else {
			yield put(fetchAllInvestmentMadeListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllInvestmentMadeListFailure(error));
	}
}

export function* resetFetchAllInvestmentMadeListResponse() {
	yield put(fetchAllInvestmentMadeListResponseChanged());
}

export function* onFetchAllInvestmentMadeList() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_START,
		fetchAllInvestmentMadeListFun,
	);
}

export function* onFetchAllInvestmentMadeListResponseReset() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_RESET,
		resetFetchAllInvestmentMadeListResponse,
	);
}

/************** FETCH ALL INVESTMENT REPAYMENT LIST START ************************** */
export function* fetchAllInvestmentRepaymentListFun({ payload }: any) {
	const { Limit, BranchID, investorID, databaseName } = payload;
	try {
		const key = 'FetchAllInvestmentRepaymentListKey';
		const jsonData = {
			Limit: Limit,
			branchID: BranchID,
			investorID: investorID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllInvestmentRepaymentList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllInvestmentRepaymentListFailure(responseData.data));
		} else {
			yield put(fetchAllInvestmentRepaymentListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllInvestmentRepaymentListFailure(error));
	}
}

export function* resetFetchAllInvestmentRepaymentListResponse() {
	yield put(fetchAllInvestmentRepaymentListResponseChanged());
}

export function* onFetchAllInvestmentRepaymentList() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_START,
		fetchAllInvestmentRepaymentListFun,
	);
}

export function* onFetchAllInvestmentRepaymentListResponseChanged() {
	yield takeLatest(
		funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_RESET,
		resetFetchAllInvestmentRepaymentListResponse,
	);
}

/************** CREATE INVESTOR MADE START ************************** */
export function* createInvestorMadeSagaFun({ payload }: any) {
	const {
		databaseName,
		investmentAmount,
		investmentDetails,
		investorID,
		interestPercentage,
		Tenure,
		TenureType,
		isRepaymentSchedule,
		HOloanIndexID,
		investmentDate,
		LoanDataforDiminishing,
	} = payload;
	try {
		const key = 'createInvestorMadeKey';
		const jsonData = {
			databaseName,
			hOloanIndexID: HOloanIndexID,
			tennre: Tenure,
			tennreType: TenureType,
			interestPercentage,
			investmentAmount,
			investmentDate,
			investmentDetails,
			investorID,
			isRepaymentSchedule,
			loanDataforDiminishing: LoanDataforDiminishing ?? [],
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createInvestorMadeFun, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createInvestorMadeFailure(responseData.data));
		} else {
			yield put(createInvestorMadeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createInvestorMadeFailure(error));
	}
}

export function* resetcreateInvestorMadeResponse() {
	yield put(createInvestorMadeChanged());
}

export function* onCreateInvestorMadeReset() {
	yield takeLatest(
		funderDetailsActionTypes.CREATE_INVESTOR_MADE_START,
		createInvestorMadeSagaFun,
	);
}

export function* oncreateInvestorMadeResponseChanged() {
	yield takeLatest(
		funderDetailsActionTypes.CREATE_INVESTOR_MADE_RESET,
		resetcreateInvestorMadeResponse,
	);
}
/************** CREATE INVESTOR MADE START ************************** */
export function* getInvestorDetailsSagaFun({ payload }: any) {
	const { databaseName, investorID } = payload;
	try {
		const key = 'getInvestorDetailsKey';
		const jsonData = {
			databaseName,
			investorID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getInvestorDetailsFun, encodeData);
		console.log('responseData.........', responseData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getInvestorsDetailsFailure(responseData.data));
		} else {
			yield put(getInvestorsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getInvestorsDetailsFailure(error));
	}
}

export function* resetGetInvestorDetailsResponse() {
	yield put(getInvestorsDetailsChanged());
}

export function* onGetInvestorDetailsReset() {
	yield takeLatest(
		funderDetailsActionTypes.GET_INVESTORS_DETAILS_START,
		getInvestorDetailsSagaFun,
	);
}

export function* onGetInvestorDetailsResponseChanged() {
	yield takeLatest(
		funderDetailsActionTypes.GET_INVESTORS_DETAILS_RESET,
		resetGetInvestorDetailsResponse,
	);
}

/************** CREATE INVESTOR MADE START ************************** */
export function* getBranchAccountListSagaFun({ payload }: any) {
	const { databaseName, infogID, branchId } = payload;
	try {
		const key = 'getBranchAccountListKey';
		const jsonData = {
			databaseName,
			infogID,
			branchId,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBranchAccountListFun, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchAccountListFailure(responseData.data));
		} else {
			yield put(getBranchAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchAccountListFailure(error));
	}
}

export function* resetgetBranchAccountListResponse() {
	yield put(getBranchAccountListChanged());
}

export function* ongetBranchAccountListReset() {
	yield takeLatest(
		funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_START,
		getBranchAccountListSagaFun,
	);
}

export function* ongetBranchAccountListResponseChanged() {
	yield takeLatest(
		funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_RESET,
		resetgetBranchAccountListResponse,
	);
}

/************** Get Repayment Schedule START ************************** */
export function* getRepaymentSchedule({ payload }: any) {
	const { investerId, investmentMadeID, databaseName } = payload;
	try {
		const key = 'getRepaymentScheduleDetailsKey';
		const jsonData = {
			databaseName,
			investerId,
			investmentMadeID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getRepaymentScheduleDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRepaymentScheduleFailure(responseData.data));
		} else {
			yield put(getRepaymentScheduleSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRepaymentScheduleFailure(error));
	}
}

export function* resetRepaymentScheduleResponse() {
	yield put(getRepaymentScheduleChanged());
}

export function* ongetRepaymentSchedulestart() {
	yield takeLatest(funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_START, getRepaymentSchedule);
}

export function* onGetRepaymentScheduleListResponseChanged() {
	yield takeLatest(
		funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_SUCCESS,
		resetRepaymentScheduleResponse,
	);
}
export function* funderDetailsSaga() {
	yield all([
		call(onGetInvestorDetailsReset),
		call(onGetInvestorDetailsResponseChanged),
		call(onGetFunderDetailsListStart),
		call(onGetFunderDetailsListReset),
		call(onAddFunderDetailsStart),
		call(onAddFunderDetailsReset),
		call(onUpdateFunderDetailsStart),
		call(onUpdateFunderDetailsReset),
		call(onDeleteFunderDetailsStart),
		call(onDeleteFunderDetailsReset),
		call(onFetchInvestmentProductInvestmentAmount),
		call(onFetchInvestmentProductInvestmentAmountResponseReset),
		call(onFetchAllInvestmentMadeList),
		call(onFetchAllInvestmentMadeListResponseReset),
		call(onFetchAllInvestmentRepaymentList),
		call(onFetchAllInvestmentRepaymentListResponseChanged),
		call(onCreateInvestorMadeReset),
		call(oncreateInvestorMadeResponseChanged),
		call(ongetBranchAccountListResponseChanged),
		call(ongetBranchAccountListReset),
		call(ongetRepaymentSchedulestart),
		call(onGetRepaymentScheduleListResponseChanged),
	]);
}
